import AuthService from "../login/auth.service";
import { ruedas, cuentas, comprobantes } from "../../components/generico/utils/UrlAPI";
import axios from "axios";
import moment from 'moment';

class RuedaService {
  async getCuentas(tipo) {
    var data = JSON.stringify({
      canal: "WEB",
      estado: null,
      modalidad: null,
      moneda: "GS",
      tipo: tipo,
      tipoCuenta: null
    });

    var config = {
      method: "post",
      url: cuentas + "socio-cuenta/transferencias",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }
  async obtenerGruposRueda() {

    var data = JSON.stringify({ canal: "WEB" });
    var config = {
      method: "post",
      url: ruedas + "adquisiciones/obtener-ruedas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async confirmarCompraRueda(nroCuenta, nroContrato, grupo) {
    var data = JSON.stringify({
      canal: "WEB",
      cuenta: nroCuenta,
      grupo: grupo,
      contrato: nroContrato,
    });

    var config = {
      method: "post",
      url: ruedas + "adquisiciones/compras",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }
  async descagarComprobante(titulo, nroOperacion, nroSocioTitular, cuenta, moneda, nroContrato, fechaPrimerVencimiento, fechaVencimiento, totalDebito, importeCuota) {
    var _url = comprobantes + "comprobantes/v2/adquisicion-rueda";

    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      nroSocioTitular: nroSocioTitular,
      cuentaDebito: cuenta,
      moneda: moneda,
      nroContrato: nroContrato,
      fechaPrimerVencimiento: fechaPrimerVencimiento,
      fechaVencimientoRueda: fechaVencimiento,
      totalDebito: totalDebito,
      importeCuota: importeCuota
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }

  async descagarComprobanteReimpRueda(datos, datosCabecera, nombre) {

    var _url = comprobantes + "comprobantes/reimpresion/comprobantes";

    const isoDate = datos.fechaEstado;
    const fechaOperacion = moment(isoDate).format('DD/MM/YYYY hh:mm A');
    var data = JSON.stringify({
      titulo: "Pago de Rueda",
      nroOperacion: datos.comprobante,
      cuentaTitular: nombre,
      tipo: "",
      moneda: "GS",
      cuentaDebito: datosCabecera.cuenta,
      cuentaCredito: datosCabecera.cuenta,
      mporteDebito: datos.importeDebito,
      importeCredito: datos.importeCredito,
      titularCuentaDestino: nombre,
      fechaOperacion: fechaOperacion
    });

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }

  async descagarContrato(titulo, idGrupo, nroContrato, nroCuentaAsignada, sucursal, nombreSocio, nroSocio, cedulaIdentidad, valoresPfd) {
    var _url = comprobantes + "comprobantes/v2/contrato-rueda-gigante-solidaridad";
    var today = new Date();
    var dd = String(today.getDate());
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    var mesLestras = "";
    switch (mm) {
      case 1:
        mesLestras = "Enero";
        break;
      case 2:
        mesLestras = "Febrero";
        break;
      case 3:
        mesLestras = "Marzo";
        break;
      case 4:
        mesLestras = "Abril";
        break;
      case 5:
        mesLestras = "Mayo";
        break;
      case 6:
        mesLestras = "Junio";
        break;
      case 7:
        mesLestras = "Julio";
        break;
      case 8:
        mesLestras = "Agosto";
        break;
      case 9:
        mesLestras = "Setiembre";
        break;
      case 10:
        mesLestras = "Octubre";
        break;
      case 11:
        mesLestras = "Noviembre";
        break;
      case 12:
        mesLestras = "Diciembre";
        break;
      default:
        break;
    }

    var fecha = dd + " días del mes de " + mesLestras + " del " + yyyy;

    var data = new Object();
    data.titulo = titulo;
    data.idGrupo = idGrupo;
    data.nroOrden = nroContrato;
    data.nroCuentaAsignada = nroCuentaAsignada;
    data.sucursal = sucursal;
    data.fecha = fecha;
    data.nombreSocio = nombreSocio;
    data.nroSocio = nroSocio;
    data.cedulaIdentidad = cedulaIdentidad;
    for (let index = 0; index < valoresPfd.length; index++) {
      //console.log(valoresPfd[index].parametro);
      data[valoresPfd[index].parametro] = valoresPfd[index].valor;
    }
    data = JSON.stringify(data);
    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

  async reimprimirContrato(_data) {

    var _url = comprobantes + "comprobantes/reimpresion/contrato-rueda-gigante-solidaridad";

    let fechaSplit = _data.fecha.split("/");

    var dd = parseInt(fechaSplit[0]);
    var mm = parseInt(fechaSplit[1]);
    var yyyy = fechaSplit[2];
    var mesLestras = "";

    switch (mm) {
      case 1:
        mesLestras = "Enero";
        break;
      case 2:
        mesLestras = "Febrero";
        break;
      case 3:
        mesLestras = "Marzo";
        break;
      case 4:
        mesLestras = "Abril";
        break;
      case 5:
        mesLestras = "Mayo";
        break;
      case 6:
        mesLestras = "Junio";
        break;
      case 7:
        mesLestras = "Julio";
        break;
      case 8:
        mesLestras = "Agosto";
        break;
      case 9:
        mesLestras = "Setiembre";
        break;
      case 10:
        mesLestras = "Octubre";
        break;
      case 11:
        mesLestras = "Noviembre";
        break;
      case 12:
        mesLestras = "Diciembre";
        break;
      default:
        break;
    }

    var fecha = dd + " días del mes de " + mesLestras + " del " + yyyy;

    _data = { ..._data, fecha };

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: _data
    };

    return await axios(config);

  }

  async obtenerParametros(grupo) {

    const _url = ruedas + "parametros";

    var config = {
      method: "get",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      params: {
        grupo
      }
    };

    return await axios(config);
  }

}
export default new RuedaService();
